export const REGEX_ACCEPT_ONLY_NUMBER = /^[0-9\b]+$/;